const MoneyFormatter = {
    supportedLocales: [
        'nl-BE',
        'nl-NL',
        'fr-BE',
        'fr-FR',
    ],
    format: (amount: number, currency: string = 'EUR', locale: string = 'nl-BE') => {
        if (! MoneyFormatter.supportedLocales.includes(locale)) {
            throw "Invalid locale"
        }

        return amount.toLocaleString(
            locale,
            { minimumFractionDigits: 2, maximumFractionDigits: 2 }
        ) + ' ' + currency;
    }
}

export default MoneyFormatter
